import LanguageApi from '@/api/LanguageApi';

const api = new LanguageApi();
const i18n = {
  state: { languages: [], fetching: false },

  getters: {
    languages: (state) => state.languages,
  },

  mutations: {
    SET_LANGUAGES: (state, languages) => {
      state.languages = languages;
    },
    SET_FETCHING_LANGUAGES: (state, fetching) => {
      state.fetching = fetching;
    },

  },
  actions: {
    loadLanguages: (context) => {
      if (context.state.fetching) { return; }

      context.commit('SET_FETCHING_LANGUAGES', true);
      api.getLanguages().then((languages) => {
        context.commit('SET_LANGUAGES', languages);
      });
    },

  },
};

export default i18n;
